import * as React from 'react';
import DashboardManager from './dashboardManager';
import useDashboardManagement from '../../../../../hooks/useDashboardManagement';
import Dashboard from '../../../../../models/dashboard';
import DashboardTypes from './DashboardTypes';
import { TableauDesktopOptions } from '../../../../../models/tableau';

interface Props {
  match: {
    params: {
      clientId: number;
      dashboardId: number;
    };
  };
}

const EditDashboard = ({
  match: {
    params: { clientId, dashboardId }
  }
}: Props) => {
  const defaultDashboard = {
    reportId: null,
    name: '',
    description: '',
    assignedTags: [],
    status: null,
    reportLevel: DashboardTypes[0].key,
    contentText: ''
  } as Dashboard;
  const [loading, setLoading] = React.useState<boolean>(true);
  const [dashboard, setDashboard] = React.useState<Dashboard>(defaultDashboard);
  const [desktopOptions, setDesktopOptions] = React.useState<TableauDesktopOptions[]>([]);
  const { fetchDashboard, fetchAllDashboardsFromTableau } = useDashboardManagement();

  React.useEffect(() => {
    if (!loading) {
      setLoading(true);
    }
    Promise.all([fetchDashboard(clientId, dashboardId), fetchAllDashboardsFromTableau(clientId)]).then(
      ([dashboard, tableauList]) => {
        setDashboard(dashboard);
        setDesktopOptions(tableauList);
        setLoading(false);
      }
    );
  }, []);

  return (
    <DashboardManager
      clientId={clientId}
      dashboard={dashboard}
      isNewDashboard={false}
      loading={loading}
      desktopOptions={desktopOptions}
    />
  );
};
export default EditDashboard;
